.card {
  transition: background-color 0.2s ease;
  background: light-dark(var(--mantine-color-body), var(--mantine-color-primaryDark-8));
}

.card:hover {
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-primaryDark-7));
  cursor: pointer;
}
